import { ErrorProps } from '../../types/types';
import { getCtaError, getErrorCodes, getErrorMessage, getErrorSubTitle, getErrorSugestions } from '../../utils/errorMessages';
import {
  Container,
  TitleError,
  TextSugestions,
  TextTop,
  Paragraph,
  ParagraphError,
  ListErrors,
  ButtonErrors,
} from './styles';

interface PageErrorProps {
  error: ErrorProps | null;
}

const PageError = ({error}: PageErrorProps) => {
  const handleRedirectButton = () => {
    if (getCtaError(error?.code ?? '') === 'Tentar novamente') {
      window.location.reload();
    } else if (getCtaError(error?.code ?? '') === 'Voltar para home') {
      window.location.href = 'https://certisign.com.br/';
    } else if (getCtaError(error?.code ?? '') === 'Voltar') {
      window.location.href = 'https://certisign.com.br/renovacao';
    } else if (getCtaError(error?.code ?? '') === 'Renovar') {
      window.location.href = 'https://certisign.com.br/renovacao';
    } else {
      window.location.href = 'https://certisign.com.br/';
    }
  }
  
  return (
    <Container>
      <TextTop>Código de erro: {error?.code}</TextTop>
      <Paragraph>{error?.correlationId}</Paragraph>
      <TitleError>{getErrorCodes(error?.code ?? '')}</TitleError>
      {getErrorSubTitle(error?.code ?? '') !== '' ? <ParagraphError>{getErrorSubTitle(error?.code ?? '')}</ParagraphError> : null}
      <TextSugestions>{getErrorSugestions(error?.code ?? '')}</TextSugestions>
      <ListErrors dangerouslySetInnerHTML={{__html: getErrorMessage(error?.code ?? '')}}/>
      <ButtonErrors onClick={handleRedirectButton}>{getCtaError(error?.code ?? 'Acessar página inicial')}</ButtonErrors>
    </Container>
  );
}

export default PageError;